import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  bootOrUpdateIntercom,
  ensureIntercomScript,
  shutdownIntercom,
  updateIntercom,
  type IntercomUserSettings,
} from "helpers/intercom";

type UseIntercomChatOptions = {
  enabled: boolean;
  intercomUserJwt: string | null;
};

const useIntercomChat = ({ enabled, intercomUserJwt }: UseIntercomChatOptions) => {
  const location = useLocation();
  const appId = import.meta.env.REACT_APP_INTERCOM_APP_ID;

  useEffect(() => {
    if (!enabled || !appId) {
      shutdownIntercom();
      return undefined;
    }

    if (!intercomUserJwt) {
      shutdownIntercom();
      return undefined;
    }

    const settings: IntercomUserSettings = {
      app_id: appId,
      intercom_user_jwt: intercomUserJwt,
    };

    ensureIntercomScript(appId, () => {
      bootOrUpdateIntercom(settings);
    });

    return () => {
      shutdownIntercom();
    };
  }, [enabled, appId, intercomUserJwt]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    updateIntercom();
  }, [enabled, location.pathname]);
};

export default useIntercomChat;
